import { SxProps, Theme } from '@mui/material';
import { startCase } from 'lodash-es';

import {
  FlexColumn,
  OverflowAwareText,
} from '~components/Order/ordersDispatchStyledComponents';
import { Ticket } from '~hooks/useTickets/models';

interface MaterialColumnProps {
  ticket: Ticket;
  sx?: SxProps<Theme>;
}

export default function MaterialColumn({ ticket, sx }: MaterialColumnProps) {
  const materialName = ticket.externalMaterialMaterialName ?? ticket.materialName;
  const quantity = ticket.externalNetWeight ?? ticket.quantity;
  const unitOfMeasure = ticket.externalNetWeightUnit ?? ticket.unitOfMeasure?.name;

  return (
    <FlexColumn sx={sx}>
      {quantity && (
        <OverflowAwareText>
          {quantity}
          {unitOfMeasure && ` ${startCase(unitOfMeasure)}`}
        </OverflowAwareText>
      )}
      {materialName && (
        <OverflowAwareText sx={{ color: 'text.secondary' }}>
          {materialName}
        </OverflowAwareText>
      )}
    </FlexColumn>
  );
}
